module.exports = __webpack_public_path__ + "static/img/6.3446dfd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productStage/6.png
// module id = NtgZ
// module chunks = 44